import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";
import { VisibilityPredicateType } from "../../../registry/visibility";
import { IntegrationKey } from "@erp/shared-types";

/**
 * Sync AP Invoice to Famous Step
 *
 * Push AP invoice draft to Famous Software ERP system.
 * This allows the invoice to be reviewed, approved, and paid
 * within the Famous system while maintaining bidirectional sync.
 *
 * Note: This is a backend-only step that requires Famous API access.
 * The handler is registered in backend/src/workflows/steps/handlers/
 */
export const syncAPInvoiceToFamousStep = defineStepConfig({
  type: "sync_ap_invoice_to_famous",
  name: "Sync Invoice to Famous",
  description: "Push AP invoice to Famous Software ERP",
  category: "Integration",
  libraryModule: "Famous",
  visibility: [
    [
      {
        type: VisibilityPredicateType.Integration,
        integration: IntegrationKey.Famous,
      },
    ],
  ],

  inputSchema: z.object({
    apInvoiceId: z.uuid(),
    organizationId: z.uuid(),
    famousVendorId: z.string().optional(),
  }),

  outputSchema: z.object({
    synced: z.boolean(),
    famousInvoiceId: z.string().optional(),
    syncError: z.string().optional(),
  }),

  configSchema: z.object({}),

  emits: [] as const,
});
